import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Router } from '@angular/router';
import { DialogService } from 'src/app/core/service/dialog.service';
import { OrdemTextUtil } from '../../util/ordem-text-util';
import { TipoOrdem } from 'src/app/core/model/enum/tipo-ordem.enum';

@Component({
  selector: 'app-acao-buttons',
  imports: [],
  templateUrl: './acao-buttons.component.html',
})
export class AcaoButtonsComponent {
  @Input() tipoOrdem: TipoOrdem;
  @Input() disabledConfirmar = false;
  @Output() onConfirmar = new EventEmitter<void>();

  constructor(
    private dialogService: DialogService,
    private router: Router
  ) {}

  public confirmacaoDialog(): void {
    this.dialogService.showConfirmation(
      OrdemTextUtil.getTextoConfirmacaoByTipoOrdem(this.tipoOrdem), 'Confirmar', 'Cancelar'
    ).subscribe(confirm => {
      if (confirm) this.onConfirmar.emit();
    });
  }

  public cancelamentoDialog(): void {
    this.dialogService.showConfirmation(['Deseja cancelar a ação?']).subscribe(confirm => {
      if (confirm) {
        this.router.navigate(['/ordem']);
      }
    });
  }

  get confirmacaoMessage(): string {
    return OrdemTextUtil.getAcaoByTipoOrdem(this.tipoOrdem);
  }
}
